import { useEffect, useState } from 'react';
import BusinessService from '../../services/businessService';
import { displayMethods } from "../../models/PaymentMethods";

const usePayments = (businessId, subChannel) => {
    const [paymentMethodsHook, setPaymentMethods] = useState([]);
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        const SearchPaymentMethods = () => {
            if(businessId && subChannel) {
                setLoading(true);
                BusinessService
                    .GetPaymentsMethods(businessId, subChannel)
                    .then(res => setPaymentMethods(res.map(item => ({ 
                        title: displayMethods[item], 
                        value: item, 
                        type: item 
                    }))))
                    .finally(() => setLoading(false));
            }
        }

        SearchPaymentMethods();
    }, [businessId, subChannel])

    return {
        paymentMethodsHook,
        loading
    }
}

export default usePayments;